module.exports = __webpack_public_path__ + "static/paragraph-3-mobile-185f8787c1d0bfdf5e3baa823d0ced1a.svg";